import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISurveyBuilder } from '../../admin/reports/csat-builder/common/create-form.helpers';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  private http: HttpClient = inject(HttpClient);

  constructor() {}

  public getBuilderData(): Observable<ISurveyBuilder> {
    return this.http.get<ISurveyBuilder>(`${environment.apiBaseUrl}/query/api/admin/survey/builder`).pipe(retry(3));
  }

  public saveBuilderData(data: ISurveyBuilder): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/command/api/admin/survey/builder`, data);
  }

  public saveCustomerSurvey(data: any): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/command/api/customer-survey`, data);
  }

  public getCustomerSurvey(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/query/api/survey/builder`);
  }
}
